import { BridgeClient } from "app/service/bridge/BridgeClient";

const CODES = new Set([
  "REVISION_CONFLICT",
  "INVALID_PAYLOAD",
  "SOURCE_UNAVAILABLE",
  "PERSISTENCE_FAILED",
  "ANALYSIS_REQUIRED",
  "BUSY"
]);
export function createDescriptionParametersApi(client = new BridgeClient()) {
  return async (action, payload = {}) => {
    let response;
    try {
      response = await client.sendMessageWithResponse(
        `description.parameters.${action}`,
        payload
      );
    } catch (failure) {
      const code =
        failure && CODES.has(failure.code) ? failure.code : "REQUEST_FAILED";
      throw Object.assign(new Error(code), { code });
    }
    if (!response || response.result !== "success" || !response.data) {
      const code =
        response && CODES.has(response.code) ? response.code : "REQUEST_FAILED";
      throw Object.assign(new Error(code), { code });
    }
    const data = response.data;
    if (action === "preview") {
      if (
        !Number.isInteger(data.source_count) ||
        data.source_count < 0 ||
        data.source_count > 5000 ||
        !Number.isInteger(data.value_count) ||
        data.value_count < 0 ||
        data.value_count > 5000 ||
        typeof data.truncated !== "boolean" ||
        !Array.isArray(data.groups) ||
        data.groups.length > 20 ||
        data.groups.length > data.value_count ||
        data.groups.some(
          group =>
            !group ||
            typeof group.value !== "string" ||
            !Array.isArray(group.sources) ||
            group.sources.length > 5000 ||
            group.sources.some(value => typeof value !== "string")
        )
      ) {
        throw Object.assign(new Error("REQUEST_FAILED"), {
          code: "REQUEST_FAILED"
        });
      }
      return data;
    }
    if (
      !Number.isInteger(data.revision) ||
      !data.scope ||
      (action === "catalog"
        ? !Array.isArray(data.items)
        : !data.job || !data.config || !data.application)
    ) {
      throw Object.assign(new Error("REQUEST_FAILED"), {
        code: "REQUEST_FAILED"
      });
    }
    if (action === "catalog") {
      // PHP encodes maps with consecutive numeric keys as JSON arrays (including key "0").
      // Normalize both representations before editing; writes always serialize object maps.
      return {
        ...data,
        groups: Object.fromEntries(Object.entries(data.groups || {})),
        items: data.items.map(item => ({
          ...item,
          decision: item.decision
            ? {
                ...item.decision,
                value_aliases: Object.fromEntries(
                  Object.entries(item.decision.value_aliases || {})
                )
              }
            : null
        }))
      };
    }
    if (
      (action === "settings" || data.policy !== undefined) &&
      (!data.policy ||
        typeof data.policy.enabled !== "boolean" ||
        typeof data.policy.refresh_before_rebuild !== "boolean")
    ) {
      throw Object.assign(new Error("REQUEST_FAILED"), {
        code: "REQUEST_FAILED"
      });
    }
    return data;
  };
}
